













































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { User, Schedules, Global } from '@/store';
import DeleteCurve from '@/pages/curves/DeleteCurve.vue';
import DaliDimmingInfo from '@/pages/curves/DaliDimmingInfo.vue';
import TableCellChips from '@/components/TableCellChips.vue';

@Component({ components: { DeleteCurve, DaliDimmingInfo, TableCellChips } })
class CurvesManagement extends Vue {
  @User.State('project') project;
  @Schedules.State('userCurves') curves;
  @Schedules.State('schedules') schedules;
  @Schedules.Action('loadUserCurves') loadUserCurves;
  @Schedules.Action('loadSchedules') loadSchedules;
  @Global.State('lang') lang;
  @Global.State('readonly_user') readonly_user;
  @Global.Mutation('setPageTitle') setPageTitle;

  isLoading = false;
  currentHeaderClass = '';
  checkbox_color = '#812E81';
  search = '';
  curve_to_delete = null;

  mounted() {
    this.setPageTitle('Light Curve Management');
    this.load();
  }

  updated() {
    this.currentHeaderClass = this.lang === 'en' ? 'text-xs-left' : 'text-xs-right';
  }

  /*
    Curves are only ever applied to devices through a schedule, so which schedules use a
    curve is the one piece of context that says whether editing it is harmless.
  */
  get curve_schedules_map() {
    const map = {};
    this.curves.forEach((curve) => {
      map[curve.id] = (this.schedules || [])
        .filter((schedule) => Array.isArray(schedule.curves) &&
          schedule.curves.some((date_curve) => date_curve.id === curve.id))
        .map((schedule) => ({ id: schedule.id, name: schedule.name }))
        .sort((schedule1, schedule2) => `${schedule1.name}`.localeCompare(`${schedule2.name}`));
    });
    return map;
  }

  get has_curves() {
    return this.curves.length > 0;
  }

  get is_filtering() {
    return !!(this.search || '').trim();
  }

  get filtered_curves() {
    const query = (this.search || '').trim().toLowerCase();
    if (!query) return this.curves;
    return this.curves.filter((curve) => `${curve.name || ''}`.toLowerCase().includes(query));
  }

  @Watch('project')
  async load() {
    if (!this.project) return;
    this.isLoading = true;
    this.search = '';
    // Both live in project properties; the schedules are what fills the usage column.
    await this.loadSchedules({ projectId: this.project.id });
    await this.loadUserCurves();
    this.isLoading = false;
  }

  goToCreateCurve() {
    this.$router.push('/curves/create');
  }

  goToCurve(curve_id) {
    this.$router.push(`/curves/${curve_id}`);
  }
}

export default CurvesManagement;
